import { useEffect, useState } from 'react';

//components
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import ReactMarkdown from 'react-markdown';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';
import AddAnalysisFile from '../AddAnalysisFile';

const UploadedFiles = ({ projectId}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [markdownContent, setMarkdownContent] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false);
  const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);
  const [showForm, setShowForm] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [reloadList, setReloadList] = useState(false);

  //chiamata GET dei file per progetto
  useEffect(() => {
    const fetchProjectFiles = () => {
      ProjectManagementService.getProjectFiles(projectId, (data) => {
        if (data && data.results && Array.isArray(data.results.items)) {
          setUploadedFiles(data.results.items); 

        } else {
        console.error("La risposta API per i file di analisi non contiene 'results.items' come array valido:", data);
          setUploadedFiles([]); 
      }
      });
    };

    fetchProjectFiles();
  }, [projectId, reloadList]);

  //chiamata DELETE per un file
  const handleDeleteFile = (fileId) => {
    ProjectManagementService.deleteProjectFile(fileId, () => {
      console.log(`File con ID ${fileId} eliminato con successo.`);
      setUploadedFiles(uploadedFiles.filter((file) => file.id !== fileId));
    });
  };

  const handleAddFileAnalysis = () => {
    setReloadList((prevState) => !prevState);
    setShowForm(false);
  };

  //anteprima pdf e md
  const handlePreview = (file) => {
    if (file) {
      if (file.file_type === 'pdf') {
        const downloadUrl = file.file_url;
        const fileName = file.name || 'download';
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (file.file_type === 'md') {
        const downloadUrl = file.file_url;
        const token = localStorage.getItem('token');
        ProjectManagementService.fetchMarkdownContent(
          downloadUrl,
          token,
          setMarkdownContent
        );
        setSelectedFileForPreview(file);
        setPreviewVisible(true);
      } else {
        console.log('Anteprima non disponibile per questo tipo di file.');
      }
    } else {
      console.log('File non trovato con ID:', file.id);
    }
  };

  const hidePreviewDialog = () => {
    setPreviewVisible(false);
    setMarkdownContent('');
    setSelectedFileForPreview(null);
  };

  

  return (
    <div
      style={{ width: '50%' }}
      className="uploadedFiles__Container"
    >
      <div>
        <Button
          type='button'
          onClick={() => setShowForm(true)}
          style={{ margin: ' 2rem 0' }}
        >
          Aggiungi File di Analisi
        </Button>
        <Dialog
          header="Aggiungi File di Analisi"
          visible={showForm}
          style={{ width: '50vw' }}
          modal
          onHide={() => setShowForm(false)}
        >
          <AddAnalysisFile
            projectId={projectId}
            onAddFileAnalysis={handleAddFileAnalysis}
          />
        </Dialog>
      </div>
      <h4>Lista File Caricati</h4>
      {uploadedFiles
        ? uploadedFiles.map((file, index) => (
            <ul key={index} className="addAnalysisFiles__List">
              <li className="addAnalysisFile__ListItem" onClick={() => handlePreview(file)}>
                <span className='elaborationDetail__PreviewText'>
                  - {file.name} {file.description ? (<span>| {file.description}</span>): null}
                </span>

                <div className="addAnalysisFile__ListBtn">
                  <Button
                    icon="pi pi-times"
                    rounded
                    severity="danger"
                    style={{ marginLeft: '0.5rem'}}
                    aria-label="Cancel"
                    onClick={() => handleDeleteFile(file.id)}
                  />
                </div>
              </li>
            </ul>
          ))
        : null}
      {selectedFileForPreview && (
        <Dialog
          header={`Anteprima ${selectedFileForPreview.name}`}
          visible={previewVisible}
          style={{ width: '80vw', height: '80vh' }}
          onHide={hidePreviewDialog}
          maximizable
        >
          {selectedFileForPreview.file_type === 'md' ? (
            <div
              style={{
                height: '100%',
                overflowY: 'auto',
                border: '1px solid #ccc',
                padding: '10px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <ReactMarkdown>{markdownContent}</ReactMarkdown>
            </div>
          ) : (
            <p>
              Anteprima non disponibile, questo tipo di file verrà scaricato.
              Controlla nella cartella Download.
            </p>
          )}
        </Dialog>
      )}
    </div>
  );
};

export default UploadedFiles;
